import React from 'react'

interface Props {
  children?: React.ReactNode
}

interface State {
  isError: boolean
}

class ErrorComponent extends React.Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      isError: false
    }
  }

  componentDidCatch (error: Error, info: React.ErrorInfo) {
    this.setState({ isError: true })
    console.error(error, info)
  }

  render () {
    if (this.state.isError) {
      return <div>Something went wrong</div>
    }
    return this.props.children as React.ReactElement
  }
}

export default ErrorComponent
